import { Button } from '@main/complykit/components/button';
import { forwardRef, ReactNode } from 'react';

export interface TableButtonProps {
  variant?: 'outline' | 'ghost';
  isDisabled?: boolean;
  onClick?: () => void;
  children: ReactNode;
}

export const TableButton = forwardRef<HTMLElement, TableButtonProps>(
  ({ variant = 'outline', isDisabled, onClick, children }, ref) => {
    return (
      <Button ref={ref} variant={variant} isDisabled={isDisabled} onPress={() => onClick?.()}>
        {children}
      </Button>
    );
  },
);
